module.exports = __webpack_public_path__ + "img/media3.a276814f.png";